<template>
  <app-layout :heading="$t('heading')">
    <v-card>
      <v-card-text>
        <v-form
          v-model="isFormValid"
          @keyup.native.enter="createEmployee">
          <v-subheader class="v-subheader-margin-left">{{ $t('personalSettings') }}</v-subheader>
          <v-text-field
            v-model="employee.number"
            :error-messages="errorMessages['employee.number']"
            :label="$t('number')"
            class="ml-3"/>
          <v-layout>
            <v-text-field
              v-model="employee.first_name"
              :error-messages="errorMessages['employee.first_name']"
              :label="$t('firstName') + '*'"
              :rules="[$rules.isRequired]"
              class="ml-3"
            />
            <v-text-field
              v-model="employee.last_name"
              :error-messages="errorMessages['employee.last_name']"
              :label="$t('lastName') + '*'"
              :rules="[$rules.isRequired]"
              class="ml-3"
            />
          </v-layout>

        </v-form>

        <employee-settings-schema
          :errors="errorMessages"
          :is-employee-data-filled="isFormValid"
          :employee-create="true"
          :loading="isLoading"
          @clearErrors="errorMessages = {}"
          @onCreate="createEmployee"
        />
      </v-card-text>
    </v-card>
  </app-layout>
</template>

<script>
import EmailInput from '@/components/global-components/inputs/EmailInput.vue'
import CompanyApi from '@/api/CompanyApi'
import EmployeeSettingsSchema from '@/components/routes/employees/settings/EmployeeSettingsSchema'

export default {
  name: 'EmployeeCreate',
  components: { EmployeeSettingsSchema, EmailInput },
  props: ['dialog'],
  data () {
    return {
      isFormValid: false,
      isLoading: false,
      errorMessages: {},
      employee: {
        number: '',
        first_name: '',
        last_name: ''
      }
    }
  },
  methods: {
    async createEmployee (schema) {
      if (!this.isFormValid) return

      if (schema.salary_group_id) {
        this.employee.salary_group_id = schema.salary_group_id
      }

      this.isLoading = true
      try {
        await this.$notification(CompanyApi.createCompanyEmployee({
          employee: this.employee,
          schema: schema
        }))
        this.$router.push({ name: 'employees' })
      } catch (e) {
        this.errorMessages = e
      }
      this.isLoading = false
    }
  },
  i18n: {
    messages: {
      en: {
        cancel: 'Cancel',
        create: 'Save employee',
        firstName: 'First name',
        heading: 'Add a new employee',
        lastName: 'Last name',
        number: 'Employee number',
        personalSettings: 'Personal'
      },
      tr: {
        cancel: 'İptal',
        create: 'Çalışanı kaydet',
        firstName: 'İsim',
        heading: 'Yeni çalışan ekle',
        lastName: 'Soyisim',
        number: 'Çalışan numarası',
        personalSettings: 'Personel'
      },
      de: {
        cancel: 'Abbrechen',
        create: 'Speichern',
        firstName: 'Vorname',
        heading: 'Neuer Mitarbeiter',
        lastName: 'Nachname',
        number: 'Mitarbeiternummer',
        personalSettings: 'Pers. Einstellungen'
      },
      ru: {
        cancel: 'Отмена',
        create: 'Создать сотрудника',
        firstName: 'Имя',
        heading: 'Добавить нового сотрудника',
        lastName: 'Фамилия',
        number: 'Номер сотрудника',
        personalSettings: 'Персональные данные'
      }
    }
  },
  watch: {
    employee: {
      deep: true,
      handler () { this.errorMessages = {} }
    }
  }
}
</script>

<style scoped>
  .v-subheader-margin-left {
    margin-left: -1em;
  }
</style>
